import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { string_type, bool_type, union_type, record_type, array_type, class_type, option_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { updateDocument, updateCategory, removeCategory, addDocument, removeDocument, addDocuments, MachineCategory, DocumentFilter, globalDocumentSortKeys, DocumentFilter_get_empty, DocumentDragForm_$reflection, MachineCategory_$reflection, DocumentFilter_$reflection } from "./DocumentHelpers.js";
import { Document$, DocumentCategory_$reflection, Document$_$reflection } from "../Shared/ApiDataTypes.js";
import { Tree_append, Tree$2, Tree$2_$reflection } from "../Shared/Tree.js";
import { choose, tryPick, append, map, item } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createContext } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";

export class DocumentUploadForm extends Record {
    constructor(TreeId, Files) {
        super();
        this.TreeId = TreeId;
        this.Files = Files;
    }
}

export function DocumentUploadForm_$reflection() {
    return record_type("DocumentContext.DocumentUploadForm", [], DocumentUploadForm, () => [["TreeId", option_type(int32_type)], ["Files", array_type(class_type("Browser.Types.File"))]]);
}

export class ViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Folder", "Evatic", "CustomerAttachments", "NoneSelected"];
    }
}

export function ViewMode_$reflection() {
    return union_type("DocumentContext.ViewMode", [], ViewMode, () => [[["Item1", int32_type], ["Item2", int32_type]], [], [], []]);
}

export class Model extends Record {
    constructor(Editing, Filter, MachineCategories, CustomerDocs, HiddenDoc, DragTarget, EvaticDocuments, ViewMode) {
        super();
        this.Editing = Editing;
        this.Filter = Filter;
        this.MachineCategories = MachineCategories;
        this.CustomerDocs = CustomerDocs;
        this.HiddenDoc = HiddenDoc;
        this.DragTarget = DragTarget;
        this.EvaticDocuments = EvaticDocuments;
        this.ViewMode = ViewMode;
    }
}

export function Model_$reflection() {
    return record_type("DocumentContext.Model", [], Model, () => [["Editing", bool_type], ["Filter", DocumentFilter_$reflection()], ["MachineCategories", array_type(MachineCategory_$reflection())], ["CustomerDocs", array_type(Document$_$reflection())], ["HiddenDoc", option_type(Document$_$reflection())], ["DragTarget", option_type(DocumentDragForm_$reflection())], ["EvaticDocuments", array_type(Document$_$reflection())], ["ViewMode", ViewMode_$reflection()]]);
}

export function Model_get_empty() {
    return new Model(false, DocumentFilter_get_empty(), [], [], undefined, undefined, [], new ViewMode(3, []));
}

export class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddCategory", "AddDocuments", "AddCustomerDocs", "HiddenPopup", "MoveDocument", "RemoveCategory", "RemoveDocument", "RemoveEvaticDoc", "RemoveCustomerDoc", "SetSelectedFolder", "SetCustomerDocs", "SetDragTarget", "SetEditing", "SetFilter", "SetMachineTrees", "SetTrees", "UpdateCategory", "UpdateDocument", "UpdateEvaticDoc", "UpdateCustomerDoc", "SetEvaticDocuments"];
    }
}

export function Message_$reflection() {
    return union_type("DocumentContext.Message", [], Message, () => [[["machineId", int32_type], ["categoryIdOpt", option_type(int32_type)], ["Item3", DocumentCategory_$reflection()]], [["machineId", int32_type], ["categoryId", option_type(int32_type)], ["Item3", array_type(Document$_$reflection())]], [["Item", array_type(Document$_$reflection())]], [["Item", option_type(Document$_$reflection())]], [["toMachine", int32_type], ["toCategoryId", option_type(int32_type)], ["Item3", Document$_$reflection()]], [["machineId", int32_type], ["categoryId", int32_type]], [["machineId", int32_type], ["documentId", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", ViewMode_$reflection()]], [["Item", array_type(Document$_$reflection())]], [["Item", option_type(DocumentDragForm_$reflection())]], [["Item", bool_type]], [["Item", DocumentFilter_$reflection()]], [["machineId", int32_type], ["Item2", array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection()))]], [["Item", array_type(MachineCategory_$reflection())]], [["machineId", int32_type], ["Item2", DocumentCategory_$reflection()]], [["machineId", int32_type], ["categoryId", option_type(int32_type)], ["Item3", Document$_$reflection()]], [["Item", Document$_$reflection()]], [["Item", Document$_$reflection()]], [["Item", array_type(Document$_$reflection())]]]);
}

export function init() {
    return new Model(false, new DocumentFilter(item(0, globalDocumentSortKeys), "", false, false), [], [], undefined, undefined, [], new ViewMode(3, []));
}

function updateMachineTrees(machineId, f, machines) {
    return map((existing) => {
        if (existing.Machine.Id === machineId) {
            return new MachineCategory(existing.Machine, f(existing.Trees));
        }
        else {
            return existing;
        }
    }, machines);
}

export function addMachineTreeDocument(categoryId, documents, trees) {
    return map((tree) => addDocuments(categoryId, documents, tree), trees);
}

export function update(model, msg) {
    let parentId, mapping_2, newNodes, array_5, toId, array_10, categoryId, documents_1, documents;
    switch (msg.tag) {
        case 2:
            return new Model(model.Editing, model.Filter, model.MachineCategories, append(model.CustomerDocs, msg.fields[0]), model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 0: {
            const parentTreeIdOpt = msg.fields[1];
            const machineId_1 = msg.fields[0] | 0;
            const newNode = new Tree$2(1, [msg.fields[2], []]);
            return new Model(model.Editing, model.Filter, (parentTreeIdOpt != null) ? ((parentId = (parentTreeIdOpt | 0), updateMachineTrees(machineId_1, (mapping_2 = ((newNodes = [newNode], (tree) => Tree_append((node) => (node.Id === parentId), newNodes, tree))), (array_7) => map(mapping_2, array_7)), model.MachineCategories))) : updateMachineTrees(machineId_1, (array_5 = [newNode], (array_6) => append(array_5, array_6)), model.MachineCategories), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 4: {
            const toMove = msg.fields[2];
            const toMachineId = msg.fields[0] | 0;
            const toCategoryIdOpt = msg.fields[1];
            const machineIdOpt = map_1((machine) => machine.Id, toMove.Machine);
            if (machineIdOpt != null) {
                const fromMachineId = machineIdOpt | 0;
                console.debug("Move document from category", toMove.CategoryTreeId, "on machine", fromMachineId, "to", toCategoryIdOpt, "on machine", toMachineId);
                const updatedDocument = new Document$(toMove.Guid, toMove.Number, toMove.CustomerId, toMove.Title, toCategoryIdOpt, toMove.TypeId, tryPick((machine_1) => {
                    if (machine_1.Machine.Id === toMachineId) {
                        return machine_1.Machine;
                    }
                    else {
                        return undefined;
                    }
                }, model.MachineCategories), toMove.SourceId, toMove.Date, toMove.Uploader, toMove.IsHidden, toMove.IsDeleted, toMove.Version, toMove.Uploaded, toMove.ManuallyMoved, toMove.ContentId, toMove.Filename, toMove.ContentSizeBytes, toMove.Versions);
                let updatedCategories_2;
                const machines_5 = updateMachineTrees(fromMachineId, (array_9) => choose((tree_1) => removeDocument(updatedDocument.Guid, tree_1), array_9), model.MachineCategories);
                updatedCategories_2 = updateMachineTrees(toMachineId, (toCategoryIdOpt != null) ? ((toId = (toCategoryIdOpt | 0), (array_12) => map((tree_2) => addDocument(toId, updatedDocument, tree_2), array_12))) : ((array_10 = [new Tree$2(0, [updatedDocument])], (array_11) => append(array_10, array_11))), machines_5);
                console.debug("Moved doc:", updatedCategories_2);
                return new Model(model.Editing, model.Filter, updatedCategories_2, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
            }
            else {
                throw new Error("Called move document on document with no machine");
            }
        }
        case 5:
            return new Model(model.Editing, model.Filter, updateMachineTrees(msg.fields[0], (array_13) => choose((tree_3) => removeCategory(msg.fields[1], tree_3), array_13), model.MachineCategories), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 6: {
            const toRemoveId = msg.fields[1];
            console.debug("Customer remove document", toRemoveId);
            const updatedCategories_4 = updateMachineTrees(msg.fields[0], (array_14) => choose((tree_4) => removeDocument(toRemoveId, tree_4), array_14), model.MachineCategories);
            console.debug("Removed docs:", updatedCategories_4);
            return new Model(model.Editing, model.Filter, updatedCategories_4, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 7:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments.filter((d) => (d.Guid !== msg.fields[0])), model.ViewMode);
        case 8:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs.filter((a) => (a.Guid !== msg.fields[0])), model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 16: {
            const toUpdate = msg.fields[1];
            console.debug("Customer update document in category", toUpdate);
            return new Model(model.Editing, model.Filter, updateMachineTrees(msg.fields[0], (array_17) => map((tree_5) => updateCategory(toUpdate, tree_5), array_17), model.MachineCategories), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 17: {
            const toUpdate_1 = msg.fields[2];
            console.debug("Customer update document in category", msg.fields[1], toUpdate_1);
            return new Model(model.Editing, model.Filter, updateMachineTrees(msg.fields[0], (array_18) => map((tree_6) => updateDocument(toUpdate_1, tree_6), array_18), model.MachineCategories), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 19: {
            const toUpdate_2 = msg.fields[0];
            return new Model(model.Editing, model.Filter, model.MachineCategories, map((existing) => {
                if (existing.Guid === toUpdate_2.Guid) {
                    return toUpdate_2;
                }
                else {
                    return existing;
                }
            }, model.CustomerDocs), model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 18: {
            const doc_2 = msg.fields[0];
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, map((d_1) => {
                if (d_1.Guid === doc_2.Guid) {
                    return doc_2;
                }
                else {
                    return d_1;
                }
            }, model.EvaticDocuments), model.ViewMode);
        }
        case 9:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, msg.fields[0]);
        case 10:
            return new Model(model.Editing, model.Filter, model.MachineCategories, msg.fields[0], model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 15: {
            const trees_1 = msg.fields[0];
            console.debug("Settings trees", trees_1);
            return new Model(model.Editing, model.Filter, trees_1, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 14: {
            const newTrees = msg.fields[1];
            const machineId_6 = msg.fields[0] | 0;
            console.debug("Got new trees for machine", machineId_6, newTrees);
            return new Model(model.Editing, model.Filter, map((existing_1) => {
                if (existing_1.Machine.Id === machineId_6) {
                    return new MachineCategory(existing_1.Machine, newTrees);
                }
                else {
                    return existing_1;
                }
            }, model.MachineCategories), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
        case 3:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, msg.fields[0], model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 13:
            return new Model(model.Editing, msg.fields[0], model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 11:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, msg.fields[0], model.EvaticDocuments, model.ViewMode);
        case 12:
            return new Model(msg.fields[0], model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        case 20:
            return new Model(model.Editing, model.Filter, model.MachineCategories, model.CustomerDocs, model.HiddenDoc, model.DragTarget, msg.fields[0], model.ViewMode);
        default: {
            const toAdd = msg.fields[2];
            const machineId = msg.fields[0] | 0;
            const categoryIdOpt = msg.fields[1];
            return new Model(model.Editing, model.Filter, (categoryIdOpt != null) ? ((categoryId = (categoryIdOpt | 0), (documents_1 = map((doc_1) => (new Document$(doc_1.Guid, doc_1.Number, doc_1.CustomerId, doc_1.Title, categoryId, doc_1.TypeId, doc_1.Machine, doc_1.SourceId, doc_1.Date, doc_1.Uploader, doc_1.IsHidden, doc_1.IsDeleted, doc_1.Version, doc_1.Uploaded, doc_1.ManuallyMoved, doc_1.ContentId, doc_1.Filename, doc_1.ContentSizeBytes, doc_1.Versions)), toAdd), updateMachineTrees(machineId, (trees) => addMachineTreeDocument(categoryId, documents_1, trees), model.MachineCategories)))) : ((documents = map((doc) => (new Tree$2(0, [new Document$(doc.Guid, doc.Number, doc.CustomerId, doc.Title, undefined, doc.TypeId, doc.Machine, doc.SourceId, doc.Date, doc.Uploader, doc.IsHidden, doc.IsDeleted, doc.Version, doc.Uploaded, doc.ManuallyMoved, doc.ContentId, doc.Filename, doc.ContentSizeBytes, doc.Versions)])), toAdd), updateMachineTrees(machineId, (machineTrees) => append(machineTrees, documents), model.MachineCategories))), model.CustomerDocs, model.HiddenDoc, model.DragTarget, model.EvaticDocuments, model.ViewMode);
        }
    }
}

export const documentsCtx = createContext("Documents", Model_get_empty());

export const dispatchCtx = createContext("DocumentsDispatch", undefined);

export function Provider(providerInputProps) {
    const children = providerInputProps.children;
    const key = providerInputProps.$key;
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    console.debug("Rendering document context provider");
    const child_1 = reactApi.createElement(dispatchCtx.Provider, {
        value: patternInput[1],
    }, children);
    return reactApi.createElement(documentsCtx.Provider, {
        value: patternInput[0],
    }, child_1);
}

